import apiClient from './client';

export interface Tool {
  id: string;
  name: string;
  description?: string;
  serialNumber?: string;
  purchaseDate?: string;
  branch: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateToolRequest {
  name: string;
  description?: string;
  serialNumber?: string;
  purchaseDate?: string;
}

export interface UpdateToolRequest {
  name?: string;
  description?: string;
  serialNumber?: string;
  purchaseDate?: string;
  isActive?: boolean;
}

export const toolsApi = {
  getAll: async (): Promise<Tool[]> => {
    const response = await apiClient.get('/tools');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  getById: async (id: string): Promise<Tool> => {
    const response = await apiClient.get(`/tools/${id}`);
    return { ...response.data, id: response.data._id };
  },

  create: async (data: CreateToolRequest): Promise<Tool> => {
    const response = await apiClient.post('/tools', data);
    return { ...response.data, id: response.data._id };
  },

  update: async (id: string, data: UpdateToolRequest): Promise<Tool> => {
    const response = await apiClient.put(`/tools/${id}`, data);
    return { ...response.data, id: response.data._id };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/tools/${id}`);
  },
};
